import { render, staticRenderFns } from "./StudentExamineeAggregate.vue?vue&type=template&id=5b018d82&scoped=true"
import script from "./StudentExamineeAggregate.vue?vue&type=script&lang=js"
export * from "./StudentExamineeAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b018d82",
  null
  
)

export default component.exports